import axios from "axios";
import heic2any from "heic2any";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const CategoryDetails = () => {
  // const jobs = useLoaderData();
  const { id } = useParams(); // Get the product ID from the URL params

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProductDetails = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `https://server-gs.vercel.app/admin/main-category/${id}`
        );
        const data = await response.json();

        setProduct(data);
      } catch (error) {
        console.error("Failed to fetch product details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProductDetails();
  }, [id]);

  ///////////////////////////////// EDIT START

  const [activeTab, setActiveTab] = useState(1);

  const [title, setTitle] = useState("");
  const [images, setImages] = useState([]); // For multiple images
  const [singleImage, setSingleImage] = useState(null); // For single image
  const [showWebsite, setShowWebsite] = useState(false);
  const [isButtonLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchProductDetails = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `https://server-gs.vercel.app/admin/main-category/${id}`
        );
        const data = await response.json();

        setProduct(data);

        // Update state only if the data exists
        if (data) {
          setTitle(data.title || title); // Retain existing state if data is missing

          setImages(data.images || images); // Retain existing images if data is missing
          setSingleImage(data.singleImage || singleImage); // Retain existing single image
          setShowWebsite(data.showWebsite === true || showWebsite);
        }
      } catch (error) {
        console.error("Failed to fetch product details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProductDetails();
  }, [id]);

  // Handle image selection

  // Handle form submission
  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    const formData = new FormData();

    // Append only updated fields
    if (title) formData.append("title", title);
    if (showWebsite) formData.append("showWebsite", showWebsite);

    // Append existing images if they are not updated
    if (images.length === 0 && product?.images) {
      product.images.forEach((image) => {
        formData.append("existingImages", image);
      });
    } else {
      images.forEach((image) => {
        formData.append("images", image);
      });
    }

    // Append existing singleImage if no new singleImage is provided
    if (!singleImage && product?.singleImage) {
      formData.append("existingSingleImage", product.singleImage);
    } else {
      formData.append("singleImage", singleImage);
    }

    try {
      const response = await axios.put(
        `https://server-gs.vercel.app/update-main-category/${id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      console.log("Product updated successfully:", response.data);
      setIsLoading(false);
      Swal.fire({
        title: "Success!",
        text: "Product updated successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error updating product:", error);
      setIsLoading(false);
    }
  };

  // Function to handle tab switching
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const [isDragging, setIsDragging] = useState(false);
  const [isDraggingImages, setIsDraggingImages] = useState(false);
  const [isLoadingSingleImage, setIsLoadingSingleImage] = useState(false); // Loading state for single image
  const [isLoadingImages, setIsLoadingImages] = useState(false); // Loading state for multiple images

  // Handle drag over for single image
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  // Handle drag leave for single image
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  // Handle file drop for single image
  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      await handleFile(file, setIsLoadingSingleImage, setSingleImage); // Handle the file (convert if necessary)
      e.dataTransfer.clearData();
    }
  };

  // Handle file selection for single image
  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      await handleFile(file, setIsLoadingSingleImage, setSingleImage); // Handle the file (convert if necessary)
    }
  };

  // Handle file processing (single or multiple)
  const handleFile = async (file, setIsLoading, setImageState) => {
    setIsLoading(true); // Start loading

    try {
      // Check if the file is HEIC/HEIF
      if (
        file.name.toLowerCase().endsWith(".heic") ||
        file.name.toLowerCase().endsWith(".heif")
      ) {
        // Convert HEIC to JPEG
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8, // Adjust quality as needed
        });

        // Create a new File object with the converted blob
        const convertedFile = new File(
          [convertedBlob],
          file.name.replace(/\.heic$|\.heif$/i, ".jpeg"),
          {
            type: "image/jpeg",
          }
        );

        setImageState(convertedFile);
      } else {
        // If it's not HEIC, use the file as-is
        setImageState(file);
      }
    } catch (error) {
      console.error("Error processing file:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!product) {
    return <p>No product found</p>;
  }

  return (
    <div className="bg-gray-50 min-h-screen pb-10">
      <div className="w-full py-6 px-6 border-b border-gray-200 mb-10">
        <h1 className="text-2xl font-semibold font-roboto text-gray-500">
          Inventory Details
        </h1>
      </div>
      <div className=" mx-auto w-[95%]">
        {/* Button navigation */}

        {/* Tab content */}
        <form
          onSubmit={handleSubmit}
          encType="multipart/form-data"
          className="bg-white p-8 rounded-lg shadow-lg"
        >
          <div>
            {/* Left Column */}
            <div className="grid grid-cols-2 gap-5">
                <div className="flex flex-col">
                  <label className="text-xl text-gray-800 font-roboto mb-2">
                    Title
                  </label>
                  <input
                    type="text"
                    value={title}
                    className="border border-gray-300 bg-white h-12 w-full rounded-lg mt-1 p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>

                <div className="">
                <div className="flex items-center mt-4">
                  <label
                    htmlFor="toogleA"
                    className="flex items-center cursor-pointer"
                  >
                    <div className="relative">
                      <input
                        id="toogleA"
                        type="checkbox"
                        className="sr-only"
                        onChange={() => setShowWebsite(!showWebsite)}
                        checked={showWebsite}
                      />
                      <div className="w-10 h-6 bg-gray-300 rounded-full shadow-inner transition-colors duration-200"></div>
                      <div className="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-0 transition-transform duration-200"></div>
                    </div>
                    <div className="ml-3 text-gray-700 font-medium">
                      Show website!
                    </div>
                  </label>
                </div>

                {showWebsite && (
                  <div className="mt-2 ">
                    <h2 className="text-sm font-semibold text-red-600">
                      This sub category is uploaded on the website
                    </h2>
                  </div>
                )}
                </div>
              </div>
            <div className="flex flex-row gap-5 mt-10 w-full">
              <div className="space-y-6 h-full w-full">
                <div className="flex flex-col ">
                  <label className="text-lg font-roboto text-gray-700 mb-2">
                    Upload Single Image
                  </label>
                  <div
                    className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${
                      isDragging
                        ? "border-blue-500 bg-blue-50"
                        : "border-gray-300"
                    }`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                  >
                    {isLoadingSingleImage ? (
                      <div className="flex flex-col items-center">
                        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4"></div>
                        <p className="text-gray-500">Processing image...</p>
                      </div>
                    ) : singleImage ? (
                      <div className="flex flex-col items-center">
                        {singleImage instanceof File ||
                        singleImage instanceof Blob ? (
                          <img
                            src={URL.createObjectURL(singleImage)}
                            alt="Selected"
                            className="w-32 h-32 object-cover mb-4 rounded-lg"
                          />
                        ) : typeof singleImage === "string" ? (
                          <img
                            src={singleImage}
                            alt="Selected"
                            className="w-32 h-32 object-cover mb-4 rounded-lg"
                          />
                        ) : (
                          <p className="text-red-500">Invalid image file</p>
                        )}
                        <button
                          type="button"
                          onClick={() => setSingleImage(null)}
                          className="text-sm text-red-600 underline"
                        >
                          Remove Image
                        </button>
                      </div>
                    ) : (
                      <p className="text-gray-500">
                        Drag & drop a file here or click to select
                      </p>
                    )}
                    <input
                      type="file"
                      id="fileInput"
                      className="hidden"
                      onChange={handleFileChange}
                      accept="image/*, .heic, .heif"
                    />
                    <label
                      htmlFor="fileInput"
                      className="mt-2 inline-block text-blue-600 underline cursor-pointer"
                    >
                      Browse File
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full flex justify-start mt-8">
            <button
              type="submit"
              className="bg-blue-600 w-56 text-white font-roboto px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
              disabled={isButtonLoading}
            >
              {isButtonLoading ? (
                <>
                  <svg
                    className="animate-spin h-5 w-5 mr-2 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 018 8h-4l3 3 3-3h-4a8 8 0 01-8 8v-4l-3 3 3 3v-4a8 8 0 01-8-8h4l-3-3-3 3h4z"
                    ></path>
                  </svg>
                  Loading...
                </>
              ) : (
                "Create"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryDetails;
